// 用户标签相关API服务
export default class UserSignAPI {
  constructor($axios, $store) {
    this.$axios = $axios
    this.$store = $store
  }

  // 获取用户标签列表
  async getUserSigns(searchData, page) {
    const userSignData = {
      data: searchData,
      page: page,
    }

    const { data: res } = await this.$axios({
      method: 'POST',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
      },
      url: this.$store.getters.path.config_userSign_query,
      data: userSignData,
      params: {
        username: this.$store.getters.username,
        token: this.$store.getters.token,
      },
    })

    return res
  }

  // 更新用户标签
  async updateUserSigns(data) {
    const userInfo = {
      data: JSON.parse(JSON.stringify(data)),
    }

    const { data: res } = await this.$axios({
      method: 'POST',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
      },
      url: this.$store.getters.path.config_userSign_update,
      data: userInfo,
      params: {
        username: this.$store.getters.username,
        token: this.$store.getters.token,
      },
    })

    return res
  }

  // 删除用户标签
  async deleteUserSign(id) {
    const { data: res } = await this.$axios({
      method: 'POST',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
      },
      url: this.$store.getters.path.config_userSign_delete,
      data: {
        id: id,
      },
      params: {
        username: this.$store.getters.username,
        token: this.$store.getters.token,
      },
    })

    return res
  }

  // 复核查询
  async reviewQuery(reviewData) {
    const { data: res } = await this.$axios({
      method: 'POST',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
      },
      url: this.$store.getters.path.config_userSign_review,
      data: reviewData,
      params: {
        username: this.$store.getters.username,
        token: this.$store.getters.token,
      },
    })

    return res
  }

  // 获取分类选项
  async getSignType() {
    const { data: res } = await this.$axios({
      method: 'GET',
      url: this.$store.getters.path.const_all,
      params: {
        username: this.$store.getters.username,
        token: this.$store.getters.token,
        className: 'com.quhong.enums.UserSignType',
      },
    })

    return res
  }

  // 获取主播阶段
  async getHostType() {
    const { data: res } = await this.$axios({
      method: 'GET',
      url: this.$store.getters.path.const_all,
      params: {
        username: this.$store.getters.username,
        token: this.$store.getters.token,
        className: 'com.quhong.enums.TaskPhase',
      },
    })

    return res
  }

  // 获取渠道选项
  async getChannel() {
    const { data: res } = await this.$axios({
      method: 'POST',
      url:
        this.$store.getters.path.channelList +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token,
    })

    return res
  }

  // 获取国家选项
  async getCountryCode() {
    const { data: res } = await this.$axios({
      method: 'POST',
      url:
        this.$store.getters.path.normal_country +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token,
    })

    return res
  }

  // 获取模板选项
  async getSignTemplate() {
    const { data: res } = await this.$axios({
      method: 'GET',
      url: this.$store.getters.path.const_all,
      params: {
        username: this.$store.getters.username,
        token: this.$store.getters.token,
        className: 'com.quhong.enums.UserSignTemplateType',
      },
    })

    return res
  }

  // 获取手机型号列表
  async getPhoneModels() {
    const { data: res } = await this.$axios({
      method: 'POST',
      url: this.$store.getters.path.config_userSign_query_iphone_model_list,
    })

    return res
  }
} 